<script>
import appConfig from '../../../../../shared/helpers/appConfig';
export default {
  name: "InfoModal",
  props: {
    shareEmail: {
      type: String,
      default: appConfig('VUE_APP_GOOGLE_SHEET_EMAIL')
    }
  },
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async copyEmail() {
      try {
        await navigator.clipboard.writeText(this.shareEmail);
        this.copied = true;
        setTimeout(() => (this.copied = false), 2000);
      } catch (e) {
        console.error("Failed to copy:", e);
      }
    }
  }
};
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-slate-800/80 dark:bg-slate-900/80 z-50">
    <div class="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-lg w-[600px] max-h-[90vh] overflow-y-auto border border-slate-200 dark:border-slate-700">
      <!-- Header -->
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-slate-800 dark:text-slate-100">
          Add Knowledge Base (Google Sheet)
        </h1>
        <woot-button
          variant="clear"
          color-scheme="secondary"
          icon="dismiss"
          class="hover:bg-slate-100 dark:hover:bg-slate-700 rounded-full"
          @click="close"
        />
      </div>

      <!-- Steps -->
      <ol class="space-y-6 text-slate-700 dark:text-slate-200 list-none">
        <li>
          <h2 class="font-semibold">1. Create a Google Sheet</h2>
          <details>
            <summary
              class="text-sm text-slate-500 dark:text-slate-400 cursor-pointer hover:text-slate-700 dark:hover:text-slate-200"
            >
              Start by creating a new Google Sheet to store your knowledge base content.
            </summary>
            <div
              class="mt-2 bg-slate-100 dark:bg-slate-700 rounded p-2 text-center text-slate-400 dark:text-slate-500"
            >
              <img src="/assets/images/googleSheet/step-1.png" alt="step-1" class="w-full h-auto object-contain max-w-full" />
            </div>
          </details>
        </li>

        <li>
          <h2 class="font-semibold">2. Share the sheet with our system</h2>
          <details>
            <summary
              class="text-sm text-slate-500 dark:text-slate-400 cursor-pointer hover:text-slate-700 dark:hover:text-slate-200"
            >
              Click <strong>Share</strong>, then add the following email as a <strong>Viewer</strong>:
            </summary>
            <div
              class="mt-2 bg-slate-100 dark:bg-slate-700 rounded p-2 text-center text-slate-400 dark:text-slate-500"
            >
              <img src="/assets/images/googleSheet/step-2.png" alt="step-2" class="w-full h-auto object-contain max-w-full" />
            </div>
          </details>
          <div class="mt-2 flex items-center gap-2">
            <div
              class="flex-1 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded p-2 font-mono text-sm text-slate-700 dark:text-slate-200 truncate"
            >
              {{ shareEmail }}
            </div>
            <button
              class="px-3 py-2 text-xs rounded bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 transition text-slate-700 dark:text-slate-200"
              @click="copyEmail"
            >
              <span v-if="copied">✅ Copied</span>
              <span v-else>Copy</span>
            </button>
          </div>
        </li>

        <li>
          <h2 class="font-semibold">3. Click “Add Knowledge” on this page</h2>
          <details>
            <summary
              class="text-sm text-slate-500 dark:text-slate-400 cursor-pointer hover:text-slate-700 dark:hover:text-slate-200"
            >
              Use the button here in the app to start adding your sheet as a knowledge base.
            </summary>
            <div
              class="mt-2 bg-slate-100 dark:bg-slate-700 rounded p-2 text-center text-slate-400 dark:text-slate-500"
            >
              <img src="/assets/images/googleSheet/step-3.png" alt="step-3" class="w-full h-auto object-contain max-w-full" />
            </div>
          </details>
        </li>

        <li>
          <h2 class="font-semibold">4. Enter details</h2>
          <details>
            <summary
              class="text-sm text-slate-500 dark:text-slate-400 cursor-pointer hover:text-slate-700 dark:hover:text-slate-200"
            >
              Provide a name for your knowledge base and paste the Google Sheet URL. And then click "Confirm".
            </summary>
            <div
              class="mt-2 bg-slate-100 dark:bg-slate-700 rounded p-2 text-center text-slate-400 dark:text-slate-500"
            >
              <img src="/assets/images/googleSheet/step-4.png" alt="step-4" class="w-full h-auto object-contain max-w-full" />
            </div>
          </details>
        </li>

        <li>
          <h2 class="font-semibold">5. Done!</h2>
          <p
            class="text-sm text-slate-500 dark:text-slate-400 cursor-pointer hover:text-slate-700 dark:hover:text-slate-200"
          >
            That’s it — your sheet is now connected and ready to use as a knowledge base.
          </p>
        </li>
      </ol>

      <!-- Action -->
      <div class="flex justify-end mt-6">
        <woot-button
          color-scheme="secondary"
          class="hover:bg-slate-100 dark:hover:bg-slate-700"
          @click="close"
        >
          Close
        </woot-button>
      </div>
    </div>
  </div>
</template>


